import { Routes, Route, Navigate } from "react-router-dom";
import Navigation from "../../../components/Navigation/Navigation.js";
import DistanceTable from "./DistanceTable.js";

const Targets = () => {
  const tabs = [
    { path: "distance145", label: "145M(Kungdo)" },
    { path: "distance90", label: "90M(TarscaShild)" },
    { path: "distance70", label: "70M(Puta)" },
    { path: "distance30", label: "30M(Zamby)" },
  ];

  return (
    <>
    <div className="top-noti">
      <p>※ 경기 시간은 현장 운영상황에 따라 변경될 수 있습니다. <strong>경기 시간 전에 경기장에 도착바랍니다.</strong></p>
      <p>※ The match schedule is subject to change depending on operational circumstances. <strong>Please arrive at the venue before the start of your match.</strong></p>
    </div>
      <Navigation tabs={tabs} basePath="/game-targets" variant="tab" />
      <Routes>
        <Route path="/" element={<Navigate to="distance145" replace />} />
        <Route path=":distanceParam" element={<DistanceTable />} />
      </Routes>
    </>
  );
};
export default Targets;
